import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text"
}
const _hoisted_4 = { class: "banan" }
const _hoisted_5 = { class: "items clearfix" }

import {reactive, onMounted , watch ,ref} from "vue";
import Nav from '@/components/nav/Index.vue';
import { getProduct } from "@/api/index";
import { useRouter , useRoute } from "vue-router";
import Tab from '@/components/produTab/Index.vue';
import Item from './Item.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;

const mb =ref(false);
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);


const router = useRouter();
const route = useRoute();
const datas: any = reactive({
  product:[],
  banner:'',
  filurl:localStorage.getItem('fileUrel'),
  productAll:'',
  type:'PRODUCT_EDUCATION',
});

 
 if(route.query.p) {
   datas.type = route.query.p;
 }
 

const getData = () =>{
  getProduct('').then((res: any) =>{

    
    datas.productAll = res.data;
    let product = JSON.parse(JSON.stringify(datas.productAll[datas.type])) ;
    for(let i = 0 ; i<  product.length;  i+=4){
        datas.product.push(product.slice(i, i+4));
      }
  });
};

const onChecked = (k: any) =>{
  datas.product= [];
  datas.type = k ;
  let product = JSON.parse(JSON.stringify(datas.productAll[k])) ;
  for(let i = 0 ; i<  product.length;  i+=4){
        datas.product.push(product.slice(i, i+4));
      }
};
const getBanner = (banner: any) => {
  datas.banner = banner;
};
onMounted(() => {
  getData();
  mb.value =props.isMobile;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value?'Mobile':'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: datas.filurl+datas.banner[0].fileName,
            alt: ""
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (datas.banner.length==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(datas.banner[0].title), 1),
            _createElementVNode("p", null, _toDisplayString(datas.banner[0].description), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Tab, {
      onOnChecked: onChecked,
      isMobile: mb.value,
      checked: datas.type
    }, null, 8, ["isMobile", "checked"]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.product, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(Item, {
            product: item,
            type: datas.type,
            isMobile: mb.value
          }, null, 8, ["product", "type", "isMobile"])
        ]))
      }), 128))
    ])
  ], 2))
}
}

})